import { useState } from "react";
import Select from "react-select";

interface Milestone {
  _id: string;
  name: string;
}

interface MilestoneOption {
  label: string;
  value: string;
  item: {
    _id: string;
    groupName: string;
    firstmilestones: Milestone[];
    lastmilestones: Milestone[];
  };
}

interface MilestoneGroupingAccordionBodyProps {
  milestoneOptions: MilestoneOption[];
  value: MilestoneOption | null;
  onChange: (option: MilestoneOption | null) => void;
}

export default function MilestoneGroupingAccordionBody({
  milestoneOptions,
  value,
  onChange,
}: MilestoneGroupingAccordionBodyProps) {
  const [activeTab, setActiveTab] = useState<"first" | "last">("first");

  return (
    <div style={{ padding: "4px 0 8px" }}>
      <Select
        isClearable
        placeholder="Select grouping milestone..."
        options={milestoneOptions}
        value={value}
        onChange={onChange}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={{
          control: (base) => ({
            ...base,
            backgroundColor: "#f0f0f0",
            border: "none",
            boxShadow: "none",
            marginBottom: 12,
          }),
          placeholder: (base) => ({ ...base, color: "#999" }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
      />

      {value?.item && (
        <div className="boxTab" style={{ marginTop: 8 }}>
          <div className="milestonetabss">
            <div
              style={{
                display: "flex",
                gap: "2px",
                borderBottom: "1px solid #eee",
              }}
            >
              <button
                onClick={() => setActiveTab("first")}
                className={`milestone-btn ${activeTab === "first" ? "activee" : ""}`}
              >
                First Mile
              </button>
              <button
                onClick={() => setActiveTab("last")}
                className={`milestone-btn ${activeTab === "last" ? "activee" : ""}`}
              >
                Last Mile
              </button>
            </div>

            <div style={{ marginTop: 12 }}>
              {activeTab === "first" &&
                value.item.firstmilestones?.map((m) => (
                  <div
                    key={m._id}
                    style={{
                      background: "#f7f7f7",
                      border: "1px solid #eee",
                      borderRadius: 6,
                      padding: "10px 12px",
                      marginBottom: 8,
                      fontSize: 13,
                    }}
                  >
                    {m.name}
                  </div>
                ))}

              {activeTab === "last" &&
                value.item.lastmilestones?.map((m) => (
                  <div
                    key={m._id}
                    style={{
                      background: "#f7f7f7",
                      border: "1px solid #eee",
                      borderRadius: 6,
                      padding: "10px 12px",
                      marginBottom: 8,
                      fontSize: 13,
                    }}
                  >
                    {m.name}
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}